import { MarketEnum } from '@model/enum/market.enum';
import { HttpService } from './../http-service';
import { ISuitabilityLoggable } from './../strategy-pattern-login/iSuitability-loggable';
import { Constants } from './../../utils/constants';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { Observable , of } from 'rxjs';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ISuitabilityWso2Service implements ISuitabilityLoggable {

  public _suitabilityPerfilI = [];

  constructor(
    private _configService: ConfigService,
    private _httpService: HttpService,
  ) { }

  suitabilityCheckMatrix(account: string, marketID: MarketEnum, securityType: string, securityRisk: number,
    symbol: string, suitabilityID?: string, profileName?: string, client_id?: number) {
    if (this._configService.isUserAssessorLogged() && (!suitabilityID || !profileName)) {
      return new Observable<any>(observer => {
        const json = { res: false, code: 400, message: 'Perfil não encontrado!' };
        observer.next(json);
      });
    } else if (!suitabilityID) {
      return new Observable<any>(observer => {
        const json = { res: false, code: 400, message: 'Perfil não encontrado!' };
        observer.next(json);
      });
    }
    const payload = {
      Data: {
        code_quote: symbol,
        type_title: 3,
        suitability_id: suitabilityID,
        client_id: client_id,
        market: marketID === MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF,
        account: Number(account)
      }
    };
    return this._httpService
      .doPost2(this._configService.getApiUrlBusenessWSO2(), '/facade/checkBounds', payload, null, null)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  postAssignBounds(account: string, symbol: string, client_id: number, user_id: number, marketID?: MarketEnum,
    securityType?: string) {
    const payload = {
      Data: {
        code_quote: symbol,
        account_client: account,
        client_id: client_id,
        type_title: 3,
        user_id: user_id,
        user_id_create: user_id,
        user_type_id: this._configService.isUserAssessorLogged() ? 1 : 2,
        contract_user_type_id: this._configService.isUserAssessorLogged() ? 1 : 2,
        investment_profile_id: 4,
      },
    };
    return this._httpService
      .doPost2(this._configService.getApiWebFeederRestSuitabilityWSO2(), '/assign_bounds/variable_income', payload, null, null)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

  suitabilityPerfilInformation(getPerfil?: boolean) {
    if (getPerfil && !this._configService.isUserAssessorLogged()) {
      if (this._suitabilityPerfilI && (this._suitabilityPerfilI.length === 0 || !this._suitabilityPerfilI.length)) {
        return this._httpService
          .doGet(this._configService.getApiWebFeederRest(), 'services/negotiation/suitabilityPerfilInformation')
          .pipe(map(response => {
            if (response && !response._isScalar) {
              this._suitabilityPerfilI = response.suitabilitys;
              return this._suitabilityPerfilI;
            }
            return [];
          }));
      } else {
        return this._suitabilityPerfilI;
      }
    } else {
      return of([]);
    }
  }

  getTermsUse(account: string) {
    if (!account) {
      return of([]);
    }
    return this._httpService
      .doGet(this._configService.getTermSuitabilityURL(), 'terms_use/terms?user=' + account)
      .pipe(map(res => {
        return res;
      }));
  }

  postTermsUse(params: any) {
    if (!params) {
      return of([]);
    }
    return this._httpService
      .doPost2(this._configService.getTermSuitabilityURL(), 'terms_use/sign', params, null, null)
      .pipe(map(res => {
        return res;
      }));
  }

}
